import { css } from 'aphrodite';
import moment, { Moment } from 'moment';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { Button } from '../../../../web/components-v2/Button';
import { ChevronLeft } from '../../../../web/components/svgs/icons/ChevronLeft';
import { ChevronRight } from '../../../../web/components/svgs/icons/ChevronRight';
import { styleSheet } from '../styles';

interface IProps {
	onChange: (dateStringValue: string) => void;
}

let persistedDate: Moment = null;
let persistedOffset = 0;

const onChangeDateFormatter = (value: Moment) => moment(value).format('YYYY-MM-DD');

export const DailySlider: React.FC<IProps> = ({ onChange }) => {
	const [dateConfig, setConfig] = useState({
		date: persistedDate || moment(),
		offset: persistedOffset,
	});

	useEffect(() => {
		persistedDate = null;
		persistedOffset = 0;
	}, []);

	const dateFormat = 'dddd, MMMM Do, YYYY';
	const today = moment();

	const handleDateChange = (offset: number) => () => {
		const date = moment(today).add(offset, 'days');
		const formatted = onChangeDateFormatter(date);

		persistedDate = date;
		persistedOffset = offset;

		setConfig({ ...dateConfig, date, offset });
		onChange(formatted);
	};

	const renderDate = dateConfig.date?.format(dateFormat)?.toString();

	return (
		<div className={css(styleSheet.dayStepper)}>
			<Button aria-label='Previous day' size='icon' variant='ghost' onClick={handleDateChange(dateConfig.offset - 1)}>
				<ChevronLeft width={16} height={16} />
			</Button>
			<span aria-live='polite' className={css(styleSheet.dayStepperLabel)}>
				{renderDate}
			</span>
			<Button aria-label='Next day' size='icon' variant='ghost' onClick={handleDateChange(dateConfig.offset + 1)}>
				<ChevronRight width={16} height={16} />
			</Button>
		</div>
	);
};
